import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';
import rgmBanner from '../assets/rgmbanner.svg';

const Navbar = () => {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1024);

  // Handle window resize
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1024);
      if (window.innerWidth > 1024) {
        setIsOpen(false); // Close mobile menu when resizing to desktop
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Close mobile menu when route changes
  useEffect(() => {
    setIsOpen(false);
  }, [location]);
  
  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-logo">
          <img src={rgmBanner} alt="怀旧游戏博物馆" className="navbar-banner" />
        </Link>
        
        {/* Hamburger menu button for mobile */}
        {isMobile && (
          <button 
            className={`hamburger-menu ${isOpen ? 'active' : ''}`} 
            onClick={() => setIsOpen(!isOpen)}
            aria-label="Toggle navigation menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        )}
        
        <div className={`navbar-links ${isMobile ? 'mobile' : ''} ${isOpen ? 'open' : ''}`}>
          <Link 
            to="/" 
            className={`navbar-link ${location.pathname === '/' ? 'active' : ''}`}
          >
            首页
          </Link>
          <Link 
            to="/feed" 
            className={`navbar-link ${location.pathname === '/feed' ? 'active' : ''}`}
          >
            游戏流
          </Link>
          <Link 
            to="/games" 
            className={`navbar-link ${location.pathname === '/games' ? 'active' : ''}`}
          >
            游戏库
          </Link>
          <Link 
            to="/search" 
            className={`navbar-link ${location.pathname === '/search' ? 'active' : ''}`}
          >
            找游戏
          </Link>
          <Link 
            to="/archives" 
            className={`navbar-link ${(
              location.pathname === '/archives' ||
              location.pathname.startsWith('/oral-history') ||
              location.pathname.startsWith('/newspaper-archive')
            ) ? 'active' : ''}`}
          >
            档案室
          </Link>
          <a 
            href="https://netplay.rgm.games" 
            className="navbar-link"
            target="_self"
          >
            联机大厅
          </a>
          <Link 
            to="/feedback" 
            className={`navbar-link ${location.pathname === '/feedback' ? 'active' : ''}`}
          >
            反馈中心
          </Link>
          <Link 
            to="/about"
            className={`navbar-link ${location.pathname === '/about' ? 'active' : ''}`}
          >
            关于我们
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
